import {LayoutVo} from '../../common/shared/api/karina/vo/LayoutVo.interface';
import {
  LayoutReferenceViewData,
  Maybe,
  MetaInfoType,
  SectionType,
  User,
} from '../generated/types';
import {createReferenceRequestVo} from './DataKey';
import {createItem} from './Item';

export function createLayoutReferenceViewDataList(
  userInfo: Maybe<User>,
  {
    dataKeyList,
    layout: {reference},
    sectionType,
    metaInfoType,
  }: {
    dataKeyList: string[];
    layout: LayoutVo;
    sectionType: SectionType;
    metaInfoType?: Maybe<MetaInfoType>;
  }
): LayoutReferenceViewData[] {
  if (!reference) {
    return [];
  }
  return dataKeyList.reduce<LayoutReferenceViewData[]>(
    (accumulator, dataKey) => {
      const {view_type, reference_key} = createReferenceRequestVo(dataKey);
      const viewItemList = reference[view_type]?.[reference_key] ?? [];
      // 이벤트 배너는 최대 4개까지 노출될 수 있으며, 3개가 노출되는 경우에는 2개만 노출시켜야 합니다.
      if (sectionType === SectionType.Event) {
        if (viewItemList.length === 3) {
          viewItemList.pop();
        } else if (viewItemList.length > 4) {
          viewItemList.splice(4);
        }
      }
      accumulator.push({
        dataKey,
        items: viewItemList.map(item =>
          createItem(userInfo, {
            viewItemVo: {
              viewItem: item,
              viewType: view_type,
              sectionType,
              metaInfoType,
            },
          })
        ),
      });
      return accumulator;
    },
    []
  );
}
